<template>
  <div class="h-100 d-block overflow-scroll">
    <b-table
      class="h-100 d-flex"
      striped
      hover
      responsive
      bordered
      :fields="fields"
      :items="dataList"
      small
    >
      <template #cell(ytdSales)="data">
        {{ data.item.ytdSales | toNumber }}
      </template>
      <template #cell(ytdSalesStockDays)="data">
        {{ data.item.ytdSalesStockDays | toNumber }}
      </template>
      <template #cell(ytdBuys)="data">
        {{ data.item.ytdBuys | toNumber }}
      </template>
      <template #cell(ytdStockTurnoverRate)="data">
        {{ data.item.ytdStockTurnoverRate | toNumber }}
      </template>
      <template #cell(connections)="data">
        {{ data.item.connections | toNumber }}
      </template>
      <template #cell(stocks)="data">
        {{ data.item.stocks | toNumber }}
      </template>
      <template #custom-foot>
        <b-tr>
          <b-th>
            Toplam
          </b-th>
          <b-th class="text-right">
            {{ grandTotals.ytdSales | toNumber }}
          </b-th>
          <b-th class="text-right">
            {{ grandTotals.ytdSalesStockDays | toNumber }}
          </b-th>
          <b-th class="text-right">
            {{ grandTotals.ytdBuys | toNumber }}
          </b-th>
          <b-th class="text-right">
            {{ grandTotals.ytdStockTurnoverRate | toNumber }}
          </b-th>
          <b-th class="text-right">
            {{ grandTotals.connections | toNumber }}
          </b-th>
          <b-th class="text-right">
            {{ grandTotals.stocks | toNumber }}
          </b-th>
        </b-tr>
      </template>
    </b-table>
  </div>
</template>
<script>
import {
  BTable, BTh, BTr,
} from 'bootstrap-vue'

export default {
  name: 'TablePerformance',
  components: {
    BTr,
    BTh,
    BTable,
  },
  props: {
    dataList: {
      type: Array,
      required: true,
    },
    grandTotals: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'title',
          label: 'Alım Kanalı',
          sortable: true,
          thClass: 'font-small-2 text-nowrap align-middle',
          tdClass: 'font-weight-bold text-nowrap text-body',
        },
        {
          key: 'ytdSales',
          label: 'YTD Satış',
          sortable: true,
          thClass: 'font-small-2 width-auto text-right align-middle',
          tdClass: 'text-right text-body',
        },
        {
          key: 'ytdSalesStockDays',
          label: 'YTD Satış Stok Gün',
          sortable: true,
          thClass: 'font-small-2 width-auto text-right align-middle',
          tdClass: 'text-right text-body',
        },
        {
          key: 'ytdBuys',
          label: 'YTD Alış Adet',
          sortable: true,
          thClass: 'font-small-2 width-auto text-right align-middle',
          tdClass: 'text-right text-nowrap text-body',
        },
        {
          key: 'ytdStockTurnoverRate',
          label: 'YTD Stok Gün',
          sortable: true,
          thClass: 'font-small-2 width-auto text-right align-middle',
          tdClass: 'text-right text-nowrap text-body',
        },
        {
          key: 'connections',
          label: 'Bağlantı',
          sortable: true,
          thClass: 'font-small-2 width-auto text-right align-middle',
          tdClass: 'text-right text-nowrap text-body',
        },
        {
          key: 'stocks',
          label: 'Stok',
          sortable: true,
          thClass: 'font-small-2 width-auto text-right align-middle',
          tdClass: 'text-right text-nowrap text-body',
        },
      ],
    }
  },
}
</script>
